export const BudgetCenterUrl = '/campaign/vnext/budgetcenter';
